import Game from "../../Game.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";
import StandardSheetAnimations from "./StandardSheetAnimations.js";

export default class Sniper extends Mob {
	constructor(sprites, infoable=true) {
		super(sprites, StandardSheetAnimations.getAnimation("sniper"));
		this.substAnimation("idle_e", 1, { row: 9, col: 0 });
		this.substAnimation("idle_w", 1, { row: 9, col: 0 });
		this.substAnimation("idle_n", 1, { row: 10, col: 0 });


		this.width = Game.ENEMY_WIDTH;
		this.height = Game.ENEMY_HEIGHT;

		let traits = {
			clas: "enemy",
			race: "sniper",
			openDoors: true,
			static: false,
			qi: BasicAI.QI_MEDIUM,
			speed: Sniper.WALK_STEP * Game.MULT,
			radius: Sniper.RADIUS,
			runspeed: Sniper.RUN_STEP * Game.MULT,
			timeWarns: Sniper.TIME_WARNS,
			infoable: infoable
		}
		this.setMobTraits(traits)
	}
	init() {
		this.mc = jQuery("#template-mob").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();

	}

}
Sniper.RADIUS = 7;
Sniper.WALK_STEP = 2;
Sniper.RUN_STEP = 4;
Sniper.TIME_WARNS = [1000, 1500];

